<template>
  <div
    class="flex items-center gap-3"
    :class="{ 'cursor-pointer': props.clickable }"
    @click="emit('click')">
    <div class="relative flex h-12 w-12 items-center justify-center">
      <component
        :is="props.icon"
        :stroke-width="2"
        :style="{
          color: `var(--sm-${props.color})`,
        }" />
      <span
        class="absolute left-0 top-0 aspect-square h-full w-full rounded-full opacity-10"
        :class="`bg-${props.color}`"></span>
    </div>
    <div>
      <h2 class="text-2xl">
        <div v-if="props.displayNumber || props.displayNumber === 0">
          <TextMultiline :text="getDispalyString(props.displayNumber)" />
        </div>
        <div v-else>
          <SmSkeleton />
        </div>
        <TextMultiline
          :text="i18n.t(props.displayI18nKey)"
          class="m-0 text-sm font-normal text-contrast-muted" />
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import { getCorrectedPrice } from '@/utils/formatter/price'
  import { Component } from 'lucide-vue-next'

  const i18n = useI18n()

  const emit = defineEmits(['click'])

  function getDispalyString(text: string | number | null) {
    if (text === null) return i18n.t('notAvailable')
    // If string --> return string
    if (typeof text === 'string') return text

    if (props.isPrice) return getCorrectedPrice(text)
    else return text.toLocaleString()
  }

  const props = defineProps({
    icon: {
      type: Object as PropType<Component>,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    displayI18nKey: {
      type: String,
      required: true,
    },
    displayNumber: {
      type: [String, Number, null],
      required: false,
      default: null,
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPrice: {
      type: Boolean,
      required: false,
      default: false,
    },
  })
</script>
